// src/pages/HelpPage.jsx
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Grid
} from '@mui/material';
import {
  HelpOutline as HelpOutlineIcon,
  MenuBook as DocumentationIcon,
  Forum as CommunityIcon, // For community forum/chat
  Email as ContactIcon,    // For email support
  Build as TroubleshootingIcon, // For troubleshooting guides
  Info as FaqIcon // For FAQs
} from '@mui/icons-material';

const HelpItem = ({ icon, primary, secondary, link }) => (
  <ListItem button component={link ? Link : 'div'} href={link} target={link ? "_blank" : undefined} rel={link ? "noopener noreferrer" : undefined}>
    <ListItemIcon sx={{minWidth: 40}}>
      {icon || <HelpOutlineIcon />}
    </ListItemIcon>
    <ListItemText primary={primary} secondary={secondary} />
  </ListItem>
);

const HelpPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Paper elevation={2} sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
          <HelpOutlineIcon sx={{ fontSize: '2.5rem', mr: 1.5, color: 'primary.main' }} />
          Help & Resources
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          Welcome to the DopomogAI Help Center. Here you can find resources to assist you in using the platform,
          troubleshooting issues, and getting the most out of its features.
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>Key Resources</Typography>
            <List component="nav" aria-label="key resources">
              <HelpItem
                icon={<DocumentationIcon color="primary" />}
                primary="Official Documentation"
                secondary="Comprehensive guides and API references."
                link="https://docs.opendevin.com" // Replace with your actual docs link
              />
              <Divider component="li" sx={{my:1}}/>
              <HelpItem
                icon={<FaqIcon color="primary" />}
                primary="Frequently Asked Questions"
                secondary="Find answers to common questions about DopomogAI."
                link="#" // Replace with your FAQ link or internal route
              />
               <Divider component="li" sx={{my:1}}/>
              <HelpItem
                icon={<TroubleshootingIcon color="primary" />}
                primary="Troubleshooting Guides"
                secondary="Step-by-step solutions for common issues."
                link="#" // Replace with your troubleshooting link
              />
            </List>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>Support & Community</Typography>
            <List component="nav" aria-label="support and community">
              <HelpItem
                icon={<CommunityIcon color="secondary" />}
                primary="Community Forum"
                secondary="Connect with other users and share insights."
                link="#" // Replace with your community forum link
              />
              <Divider component="li" sx={{my:1}}/>
              <HelpItem
                icon={<ContactIcon color="secondary" />}
                primary="Contact Support"
                secondary="Reach out to our support team for direct assistance."
                link="mailto:support@dopomog.ai" // Replace with your support email
              />
              {/* You can add more items like "Feature Requests", "Report a Bug", etc. */}
            </List>
          </Grid>
        </Grid>
        
        <Box sx={{mt: 4, pt:3, borderTop: 1, borderColor: 'divider', textAlign: 'center'}}>
            <Typography variant="body2" color="text.secondary">
                Can't find what you're looking for? Our team is always ready to help.
            </Typography>
        </Box>

      </Paper>
    </Container>
  );
};

export default HelpPage;